import {Injectable} from '@angular/core';

@Injectable({
    providedIn: 'root'
})
export class RcNumberService {

    constructor() {
    }

    /**
     * cut a number into n decimal digits and return value as float
     * @param value
     * @param number decimals
     * @param boolean round
     * @returns float
     */
    format(value: any, decimals: number = 2, round = false) {
        if (isNaN(value)) {
            return null;
        }
        const ex = Math.pow(10, decimals);
        value = Math.round(value * ex);
        value = value.toString().split('.')[0] / ex;

        if (round) {
            value = Math.round(value);
        }
        return parseFloat(value);
    }
}
